import React from 'react'
import {
  FieldGrid,
  FieldGroup,
  LabeledToggleRow,
  NumberField,
  SettingsPane,
  ToggleList,
} from '../organization-ui'
import type { OrganizationSettingsFormProps } from '../settings/organizationSettingsForm.types'

export const BreakPane: React.FC<OrganizationSettingsFormProps> = ({
  register,
  setValue,
  watch,
  errors,
  disabled = false,
}) => (
  <SettingsPane
    title="Breaks"
    description="Default break allowances and what happens when staff exceed them."
  >
    <FieldGroup label="Allowances">
      <FieldGrid>
        <NumberField
          label="Default paid break"
          min={0}
          unit="min"
          disabled={disabled}
          hint="Counted as worked time."
          error={errors.breakSettings?.defaultPaidBreakMinutes?.message}
          {...register('breakSettings.defaultPaidBreakMinutes', { valueAsNumber: true })}
        />
        <NumberField
          label="Default unpaid break"
          min={0}
          unit="min"
          disabled={disabled}
          hint="Excluded from worked time."
          error={errors.breakSettings?.defaultUnpaidBreakMinutes?.message}
          {...register('breakSettings.defaultUnpaidBreakMinutes', { valueAsNumber: true })}
        />
      </FieldGrid>
    </FieldGroup>

    <FieldGroup label="Overruns">
      <ToggleList>
        <LabeledToggleRow
          label="Auto-deduct excess break time"
          description="Deduct any break time taken beyond the allowances above."
          checked={watch('breakSettings.autoDeductExcessBreak') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('breakSettings.autoDeductExcessBreak', checked, { shouldDirty: true })
          }
        />
      </ToggleList>
    </FieldGroup>
  </SettingsPane>
)

BreakPane.displayName = 'BreakPane'
